import { render, staticRenderFns } from "./YogaCard.vue?vue&type=template&id=05547f76&scoped=true&"
import script from "./YogaCard.vue?vue&type=script&lang=js&"
export * from "./YogaCard.vue?vue&type=script&lang=js&"
import style0 from "./YogaCard.vue?vue&type=style&index=0&id=05547f76&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05547f76",
  null
  
)

export default component.exports